export const tagTypes = [
  'User',
  'Vehicles',
  'Solutions',
  'SolutionHomeOverview',
  'ImportedData',
  'ChargingHubs',
  'ChargingHubDetails',
  'DepotMapMarkers',
  'VehiclePolylines',
  'VehiclePolyline',
  'VehicleEnergyPreview',
] as const;

export type SolutionId = number | string;
export type SolutionTag = 'Solutions' | { type: 'Solutions'; id: SolutionId };
export type VehicleTag = 'Vehicles' | { type: 'Vehicles'; id: number };

export interface SolutionHomeOverviewTag {
  type: 'SolutionHomeOverview';
  id: SolutionId;
}

export interface ImportedDataTag {
  type: 'ImportedData';
  id: SolutionId;
}

export interface ChargingHubsTag {
  type: 'ChargingHubs';
  id: SolutionId;
}

export interface ChargingHubDetailsTag {
  type: 'ChargingHubDetails';
  id: SolutionId;
}

export interface DepotMapMarkersTag {
  type: 'DepotMapMarkers';
  id: SolutionId;
}

export interface VehiclePolylinesTag {
  type: 'VehiclePolylines';
  id: SolutionId;
}

export interface VehiclePolylineTag {
  type: 'VehiclePolyline';
  id: number;
}

export interface VehicleEnergyPreviewTag {
  type: 'VehicleEnergyPreview';
  id: number;
}

export type SolutionDerivedTag =
  | SolutionHomeOverviewTag
  | ImportedDataTag
  | ChargingHubsTag
  | ChargingHubDetailsTag
  | DepotMapMarkersTag
  | VehiclePolylinesTag;

export type VehicleDerivedTag = VehicleTag | VehiclePolylineTag | VehicleEnergyPreviewTag;
